// src/Camera.js
import React, {useState,useEffect} from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { BiSolidLeftArrow, BiX } from 'react-icons/bi';
import Header from "../components/Header";

import { sendAnalyticsData } from '../utilities/analytics';
const PageHint = () => {

  const navigate = useNavigate();

  return (
    <div className='full-height'>
      <Header/>
      <Link className='back page-back' onClick={() => navigate(-1)}>
        <img className='icon-back' src='/images/icon-back.png' alt=''/>
      </Link>
      <div className='hint-wrapper d-flex flex-column'>
        <div className='hint-title d-none d-desktop-block'>
          <div className='navigation'>
          </div>
            TIPS FOR IDEAL<br/><span>CAMERA POSITION</span>
        </div>
        <div className='hint-inner-wrapper'>
          <div className='hint-title d-block d-desktop-none'>
            TIPS FOR IDEAL<br/><span>CAMERA POSITION</span>
          </div>
          <div className='hint-box-wrapper'>
            <div className='hint-box'>
              <p>LIGHTING CHECK</p>
              <span>GOOD</span>
            </div>
            <div className='hint-box'>
              <p>LOOK STRAIGHT</p>
              <span>GOOD</span>
            </div>
            <div className='hint-box'>
              <p>POSITION FACE</p>
              <span>GOOD</span>
            </div>
          </div>
          <div className='hint-image-wrapper'>
            <img className='hint-image' src='/images/home-hint.png' alt=''/>
          </div>
        </div>
        <Link to={`/expert/captured`} className='btn btn-primary w-100 d-table mx-auto'>Scan</Link>
      </div>
    </div>
  );
};

export default PageHint;
